import { CalendarIcon } from "../../../assets/CalendarIcon";
import { CarIcon } from "../../../assets/CarIcon";
import { PhoneIcon } from "../../../assets/PhoneIcon";

export default function LeadFormHeader({
  isTestDriveFlow,
  isTradeIn,
  label,
  clearAttachedCar,
}: {
  isTestDriveFlow: boolean;
  isTradeIn: boolean;
  label: string;
  clearAttachedCar: () => void;
}) {
  return (
    <div className="tdb-header">
      <p className="tdb-headerTitle">
        {isTestDriveFlow ? (
          <CalendarIcon className="tdb-headerIcon" />
        ) : isTradeIn ? (
          <CarIcon className="tdb-headerIcon bigger" />
        ) : (
          <PhoneIcon className="tdb-headerIcon" />
        )}
        {label}
      </p>

      <button onClick={clearAttachedCar} className="tdb-header-button-close">
        ✕
      </button>
    </div>
  );
}
